import { render, staticRenderFns } from "./FactEditMain.vue?vue&type=template&id=c4419004&scoped=true&"
import script from "./FactEditMain.vue?vue&type=script&lang=js&"
export * from "./FactEditMain.vue?vue&type=script&lang=js&"
import style0 from "./FactEditMain.vue?vue&type=style&index=0&id=c4419004&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4419004",
  null
  
)

export default component.exports